import styled from '@emotion/styled'

import { ApiAccountApprovalEvent } from '@/api/_legacy/generated-api'
import { Section, Space, Typography } from '@/components/core-v2'
import { formatDateAsString, unpascal } from '@/modules/tradebuilder-v2/util'

export type TradeEventProps = ApiAccountApprovalEvent

const StyledComment = styled.div`
  border-bottom: solid 1px var(--White95);
`

const StyledDate = styled(Space)`
  color: var(--White60);
`

const StyledCompletedBoxBefore = styled(Space)`
  color: var(--White60);
  text-decoration: line-through;
  background-color: var(--White94);
`
const StyledCompletedBoxAfter = styled(Space)`
  color: var(--Success);
  background-color: var(--SuccessAltBG);
`

const TradeEventDisplay = ({
  comments,
  firstName,
  lastName,
  statusAfter,
  statusBefore,
  time
}: TradeEventProps) => {
  const userName = `${firstName} ${lastName}`
  const timeAsDate = new Date(time)
  const StatusBeforeSimple = `${unpascal(statusBefore)}`
  const StatusAfterSimple = `${unpascal(statusAfter)}`

  return (
    <StyledComment>
      <Space my={6}>
        <Space mb={3}>
          <Typography data-private variant="b3">
            {userName}
          </Typography>
        </Space>
        <Space mb={3}>
          <StyledDate>
            <Typography variant="b3">{formatDateAsString(timeAsDate)}</Typography>
          </StyledDate>
        </Space>
        <Space mb={5}>
          <Typography variant="b3">
            Status changed from{' '}
            <StyledCompletedBoxBefore isinline>
              <Space isinline px={1}>
                {StatusBeforeSimple}
              </Space>
            </StyledCompletedBoxBefore>{' '}
            to{' '}
            <StyledCompletedBoxAfter isinline>
              <Space isinline px={1}>
                {StatusAfterSimple}
              </Space>
            </StyledCompletedBoxAfter>
          </Typography>
        </Space>
        {comments && (
          <Section data-private p={5} type="primary">
            <Typography variant="b3">
              <Space isinline>"</Space>
              <Space isinline>{comments}</Space>
              <Space isinline>"</Space>
            </Typography>
          </Section>
        )}
      </Space>
    </StyledComment>
  )
}

export default TradeEventDisplay
